<template>
  <v-container fluid v-editable="blok" class="mt-0 mb-5 py-0">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="7" class="pa-0 ma-0">
        <v-sheet class="banner-container" color="#2AABF2" tile height="280">
          <v-container  class="fill-height">
            <v-row justify="center" align="center" >
              <v-col cols="12" class="text-left px-5">
                <h3 class="mx-5 px-5">{{blok.shortDescription}}</h3>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
      <v-col cols="12" sm="12" md="5" class="pa-0 ma-0">
        <v-sheet class="banner-container" color="#000000" tile height="280">
            <v-container  class="fill-height">
            <v-row justify="center" align="center" >
              <v-col cols="12" class="text-left px-5">
                <h4 class="ml-5">{{blok.columnTitle}}</h4>
              </v-col>
              <v-col cols="12" sm="6" class="text-left px-5">
                <ul class="ml-4">
                    <li  v-for="(item, index) in blok.bullets" :key="index">{{item.name}}</li>
                </ul>
              </v-col>
              <v-col cols="12" sm="6" class="text-left px-5">
                 <ul class="ml-4">
                    <li  v-for="(item, index) in blok.bullets2" :key="index">{{item.name}}</li>
                </ul>
              </v-col>
            </v-row>
          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./InfoTile.scss";
</style>